"use client";
import { Link } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import StatusBadge from "@/components/dashboard/StatusBadge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { useTranslation } from "react-i18next";

const tenants = [
  { id: "1", name: "Banque Léman SA", status: "success" as const, statusLabel: "Active", plan: "Enterprise", storage: 3200, storageMax: 5000, tenantId: "leman-365-prod", lastSync: "2h ago" },
  { id: "2", name: "SwissSecure AG", status: "success" as const, statusLabel: "Active", plan: "Business", storage: 1800, storageMax: 3000, tenantId: "swisssecure-365", lastSync: "4h ago" },
  { id: "3", name: "MedTech Lyon", status: "warning" as const, statusLabel: "Trial", plan: "Starter", storage: 450, storageMax: 1000, tenantId: "medtech-lyon-m365", lastSync: "1d ago" },
  { id: "4", name: "Alpine Pharma GmbH", status: "pending" as const, statusLabel: "Paused", plan: "Enterprise", storage: 2100, storageMax: 5000, tenantId: "alpine-pharma-365", lastSync: "7d ago" },
];

const Tenants = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-foreground">{t("tenants.title")}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t("tenants.subtitle")}</p>
        </div>
        <Button size="sm">{t("tenants.addTenant")}</Button>
      </div>

      <div className="rounded-lg border border-border/50 bg-card shadow-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-xs">{t("tenants.tenant")}</TableHead>
              <TableHead className="text-xs">{t("tenants.status")}</TableHead>
              <TableHead className="text-xs">{t("tenants.plan")}</TableHead>
              <TableHead className="text-xs">{t("tenants.storage")}</TableHead>
              <TableHead className="text-xs">{t("tenants.lastSync")}</TableHead>
              <TableHead className="text-xs"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tenants.map((tenant) => (
              <TableRow key={tenant.id}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-md bg-secondary">
                      <Building2 className="h-4 w-4 text-muted-foreground" />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{tenant.name}</p>
                      <p className="text-xs text-muted-foreground">{tenant.tenantId}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell><StatusBadge status={tenant.status} label={tenant.statusLabel} /></TableCell>
                <TableCell className="text-sm text-muted-foreground">{tenant.plan}</TableCell>
                <TableCell>
                  <div className="w-32">
                    <div className="flex justify-between text-xs text-muted-foreground mb-1">
                      <span>{(tenant.storage / 1000).toFixed(1)} TB</span>
                      <span>{(tenant.storageMax / 1000).toFixed(0)} TB</span>
                    </div>
                    <Progress value={(tenant.storage / tenant.storageMax) * 100} className="h-1.5" />
                  </div>
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">{tenant.lastSync}</TableCell>
                <TableCell>
                  <Link to={`/dashboard/tenants/${tenant.id}`}>
                    <Button variant="ghost" size="sm" className="gap-1">
                      <span>{t("tenants.view")}</span>
                      <ArrowRight className="h-3 w-3" />
                    </Button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default Tenants;
